export const TRUCK_ROUTE_SET_SELECTED_TAB = 'TRUCK_ROUTE_SET_SELECTED_TAB';



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/settings/types.js